
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressChequingFR]",
      function () {
        return require("private-next-pages/[...wordpressChequingFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressChequingFR]"])
      });
    }
  